var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5V15.5C22 19 20 20.5 17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9L10.13 11.5C11.16 12.32 12.85 12.32 13.88 11.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.48 2.81994L19.76 3.38993C19.9 3.66993 20.25 3.92994 20.56 3.98994L20.94 4.04994C22.08 4.23994 22.35 5.07994 21.53 5.90994L21.18 6.25993C20.95 6.49993 20.82 6.95993 20.89 7.27993L20.94 7.48994C21.25 8.86994 20.52 9.39993 19.32 8.67993L19.06 8.52993C18.75 8.34993 18.25 8.34993 17.94 8.52993L17.68 8.67993C16.47 9.40993 15.74 8.86994 16.06 7.48994L16.1099 7.27993C16.1799 6.95993 16.05 6.49993 15.82 6.25993L15.47 5.90994C14.65 5.07994 14.92 4.23994 16.06 4.04994L16.44 3.98994C16.74 3.93994 17.1 3.66993 17.24 3.38993L17.52 2.81994C18.06 1.72994 18.94 1.72994 19.48 2.81994Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsStar);
export default ForwardRef;